export default class Model {
    constructor(data, attributes) {

        // Set default attributes
        if (attributes) {
            data = { ...attributes, ...data };
        }

        // Model data
        this.data = data;
    }

    static make(data) {
        return new this(data);
    }

    relation(relation, classname) {

        // Get plain data
        let data = _.get(this.data, relation);

        // Set relation collection
        this[relation] = null;
        if (data) {
            this[relation] = new classname(data);
        }

        return this;
    }

    relationCollection(relation, classname) {

        // Get plain data
        let data = _.get(this.data, relation);

        // Map data to class
        if (data) {
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    data[key] = new classname(data[key]);
                }
            }
        }

        // Set relation collection
        this[relation] = data;

        return this;
    }

    get(key, defaultValue) {
        return _.get(this.data, key, defaultValue);
    }

    set(key, value) {
        _.set(this.data, key, value);
        return this;
    }

    delete(key) {
        _.unset(this.data, key);
        return this;
    }
}
